



































































































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import faqJson from '@/content/HelpFaqs.json';
import ProfileItem from '@/components/dumb/ProfileItem.vue';
import CallbackForm from '@/components/CallbackForm.vue';
import Analytics from '@/mixins/analytics';
export default Vue.extend({
	name: 'AgentHelp',
	components: {
		ProfileItem,
		CallbackForm
	},
	data: function(){
		return {
			showQ: false,
			show: false,
			showCallback: false,
			showQuery: false,
			showFormSummary: false,
			isHoursExpanded: false,
			rowHeight: 0,
			openFaq: [],
			dealerAgentData: {
				title: '',
				text: '',
				image: '',
				buttons: []
			},
			data: {
				faqs: [],
				faqOrder: [],
				faqDisclaimers: [],
				previousAnalytics: {
					viewSection: '',
					viewName: ''
				}
			}
		};
	},
	computed: {
		...mapState({
			agent(): any { return this.$store.state.agent },
			dealer(): any { return this.$store.state.dealer },
			dataLayer(): any { return this.$store.state.dataLayer }
		}),
		faqData(): Array<any> {
			const faqs: Array<any> = [...this.data.faqs];
			const faqHeadings = [...this.data.faqOrder.map((o)=>{
				return {
					heading: o,
					faqs: faqs.filter(o2 => o2.type == o)
				};
			})];
			return faqHeadings;
		},
		faqDisclaimers(): Array<any> {
			const faqDisclaimers: Array<any> = [...this.data.faqDisclaimers];
			return faqDisclaimers;
		},
		formattedAgentPhone(): string {
			const v = this.agent.phone.replace(/\s/g, '').substring(0, 10);
			let num;
			if (this.isMobile(v)){
				num = v.replace(/(\d{4})/, '$1 ');
				num = num.replace(/(\s+\d{3})/, '$1 ');
			}
			else {
				num = v.replace(/(\d{2})/, '$1 ');
				num = num.replace(/(\s+\d{4})/, '$1 ');
			}
			return num.trim();
		},
		showForm(): boolean {
			return !this.showFormSummary && (this.showCallback || this.showQuery);
		},
		openingFirstRow(): any {
			if (!this.dealer.openingHours.length) return {day:'',hours:''};
			return this.dealer.openingHours[0];
		},
		openingOtherRows(): Array<any> {
			if (!this.dealer.openingHours.length) return [];
			return this.dealer.openingHours.slice(1);
		}
	},
	methods: {
		handleFaqQAClick(e: any){
			console.log('click')
			if (e.target.attributes['data-modal']){
				this.$store.commit('setOpenModal', {
					video: true,
					id: 'InfoModal',
					title: 'Toyota Access',
					message: `<div class="tb-modal-iframe" data-aspect-ratio="16:9"><iframe title="vimeo-player" src="https://player.vimeo.com/video/172689671" frameborder="0" allowfullscreen></iframe></div>`,
				});
			}
		},
		isMobile(v: string): boolean {
			return 0 == v.indexOf('04');
		},
		handleFaqClick(faq: any, e: any, x: number): void {
			this.$nextTick(() => {
				Analytics.sendEvent({
					'event' : 'faqClick',
					'faqTitle' : faq.q,
					'faqToggleState' : typeof this.openFaq[x] == 'number' ? 'open' : 'close'
				});
			});
		},
		handleCloseQClick(): void {
			Analytics.sendVirtualPageView({
				"event":"omnichannelCheckOutStep",
				"viewSection": this.data.previousAnalytics.viewSection,
				"viewName": this.data.previousAnalytics.viewName
			});
			this.showQ = false;
		},
		handleCloseClick(): void {
			Analytics.sendVirtualPageView({
				"event":"omnichannelCheckOutStep",
				"viewSection": this.data.previousAnalytics.viewSection,
				"viewName": this.data.previousAnalytics.viewName
			});
			this.show = false;
		},
		handleAgentClick(): void {
			this.data.previousAnalytics = {"viewSection": this.dataLayer.viewSection, "viewName": this.dataLayer.viewName}
			Analytics.sendEvent({
				"event":"buttonClick",
				"buttonName": "Get Help"
			});
			Analytics.sendVirtualPageView({
				"event":"omnichannelCheckOutStep",
				"viewSection": "help",
				"viewName": "Help Main Screen"
			});
			this.show = true;
		},
		handleQClick(): void {
			this.data.previousAnalytics = {"viewSection": this.dataLayer.viewSection, "viewName": this.dataLayer.viewName}
			Analytics.sendEvent({
				"event":"buttonClick",
				"buttonName": "Show FAQs"
			});
			Analytics.sendVirtualPageView({
				"event":"omnichannelCheckOutStep",
				"viewSection": "help",
				"viewName": "FAQs Main Screen"
			});
			this.showQ = true;
		},
		handleExpandClick(): void {
			this.isHoursExpanded = !this.isHoursExpanded;
		},
		handleCallbackClick(): void {
			Analytics.sendEvent({
				"event": "buttonClick",
				"buttonName": "Schedule Callback"
			});
			Analytics.sendVirtualPageView({
				"event":"omnichannelCheckOutStep",
				"viewSection": "help",
				"viewName": "Help Schedule Callback Screen",
			});
			this.showCallback = !this.showCallback;
		},
		handleQueryClick(): void {
			Analytics.sendEvent({
				"event": "buttonClick",
				"buttonName": "Email Your Query"
			});
			Analytics.sendVirtualPageView({
				"event":"omnichannelCheckOutStep",
				"viewSection": "help",
				"viewName": "Help Email Screen",
			});
			this.showQuery = !this.showQuery;
		},
		handleCallbackCancelClick(): void {
			this.showQuery = false;
			this.showCallback = false;
			this.scrollToTop();
		},
		handleCallbackPosted(): void {
			this.showFormSummary = true;
			this.scrollToTop();
		},
		scrollToTop(): void {
			setTimeout(() => {
				this.$scrollTo((this as any).$refs.container, 500, {
					container: (document.querySelector('.v-dialog--active') as any)
				});
			}, 500);
		},
		setFirstRowHeight(): void {
			this.$nextTick(() => {
				const h = this.$refs.firstRow ? (this.$refs.firstRow as any).offsetHeight : 0;
				if (this.rowHeight != h){
					this.rowHeight = h;
				}
			});
		}
	},
	mounted(): void {
		Vue.set(this.data, 'faqs', faqJson.faqs);
		Vue.set(this.data, 'faqOrder', faqJson.order);
		Vue.set(this.data, 'faqDisclaimers', faqJson.disclaimers);
		for (let i = 0; i != this.faqData.length; ++i){
			(this.openFaq as any).push(null);
		}
		this.dealerAgentData.title = `Your Personal Concierge`;
		this.dealerAgentData.text = `<strong>${this.agent.firstName}</strong><br><small><strong>${this.dealer.locationName}</strong></small><br><small class="tb-agent-phone"><strong><a href="tel:${this.agent.phone}">${this.formattedAgentPhone}</a></strong></small>`;
		this.dealerAgentData.image = this.agent.photoUrl;

		(this.dealerAgentData.buttons as any).push({
			text: `Schedule callback`,
			callback: this.handleCallbackClick
		});
		(this.dealerAgentData.buttons as any).push({
			text: `Email your query`,
			callback: this.handleQueryClick
		});
		window.addEventListener('orientationchange', this.setFirstRowHeight);
	},
	updated(): void {
		this.setFirstRowHeight();
	}
});
